import {useBundlePickupPlaceCapsule} from "../bundle/tile.tsx";
import {useBundleHistoryViewProps} from "../bundle/bundle.tsx";
import {
    useJobById,
    useLastTransferForBundle,
    watchJobByIdTqo,
    watchLastTransferForBundleTqo
} from "../rpc/webrpc-client.gen.ts";
import {useQuery} from "@tanstack/react-query";
import {TruckCapsule} from "../truck/capsule.tsx";
import {buildTileActionButtons, Tile} from "../components/Tile.tsx";
import {keyify} from "../util/arutil.tsx";
import {VenuedBundle} from "../venue/overview.tsx";
import {RouterJoyLink} from "../link.tsx";
import {BundleCapsule} from "../bundle/capsule.tsx";
import {BundleSceneTileContent} from "../bundle/timeline.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function InspectorBundleTile({ixb}: { ixb: VenuedBundle }) {
    const bundle = ixb.bundle;
    const bundleId = bundle.id;
    const pickupPlaceCapsule = useBundlePickupPlaceCapsule({bundle});
    const jobTqrv = useJobById(bundle.job.id
        ? {jobId: bundle.job.id} : undefined);
    const job = jobTqrv.data;
    const jobExtras = job?.extras;
    const photoRequired = jobExtras?.shinwa?.photoRequired;
    const lastTransferTqrv = useLastTransferForBundle({bundleId});
    const lastTransfer = lastTransferTqrv.data;
    const lastTruck = lastTransfer?.truck;

    return <Tile color="primary" Subject={props =>
        <RouterJoyLink to="/bundle/$id/inspect" params={{id: bundleId}}>
            <BundleCapsule bundle={bundle} photoRequired={photoRequired} color={props.color}/>
        </RouterJoyLink>}>
        {pickupPlaceCapsule}
        {lastTruck ? <TruckCapsule truck={lastTruck}/> : null}
        {ixb.lastScene
            ? <BundleSceneTileContent scene={ixb.lastScene} color="primary"/>
            : null}
    </Tile>
}

export function SupervisorBundleTile({ixb}: { ixb: VenuedBundle }) {
    const bundleId = ixb.bundle.id;
    const mama = useMothership();
    const bundle = ixb.bundle;
    const pickupPlaceCapsule = useBundlePickupPlaceCapsule({bundle});
    const jobTqrv = useQuery(watchJobByIdTqo(mama, bundle.job.id
        ? {jobId: bundle.job.id} : undefined));
    const job = jobTqrv.data;
    const jobExtras = job?.extras;
    const lastTransferTqrv = useQuery(watchLastTransferForBundleTqo(mama, {bundleId}));
    const lastTransfer = lastTransferTqrv.data;
    const lastTruck = lastTransfer?.truck;
    const photoRequired = jobExtras?.shinwa?.photoRequired;

// const {t} = useTranslation();
// const navigate = useNavigate();
// const downloadHistoryActionProps
//    = useBundleHistoryDownloadProps({bundleId});
// const exportActionProps = {
//     color: "primary", variant: "outlined",
//     disabled: true,
//     perform: () => navigate({
//         to: exportRoute.to,
//         params: {id: bundleId},
//     }),
//     children: <FontAwesomeIcon icon={faDownload}/>
// } as const;
    const viewHistoryActionProps = useBundleHistoryViewProps({bundleId});
    const actions = buildTileActionButtons(keyify([
        viewHistoryActionProps,
// downloadHistoryActionProps,
// exportActionProps,
    ]));

    return <Tile color="primary" Subject={props =>
        <RouterJoyLink to="/bundle/$id/inspect" params={{id: bundleId}}>
            <BundleCapsule bundle={bundle} photoRequired={photoRequired} color={props.color}/>
        </RouterJoyLink>} actions={actions}>
        {pickupPlaceCapsule}
        {lastTruck ? <TruckCapsule truck={lastTruck}/> : null}
        {ixb.lastScene ? <BundleSceneTileContent scene={ixb.lastScene} color="primary"/> : null}
    </Tile>
}
